import { Reveal } from "@components/ui";

const bulletItems = [
  "Board-level oversight of sustainability strategy",
  "Regular environmental and safety audits",
  "Published annual sustainability reports",
  "Stakeholder engagement and feedback mechanisms",
  "Ethical business practices and anti-corruption policies",
  "Transparent reporting aligned with GRI Standards",
];

const GovernanceSection = () => {
  return (
    <section className="bg-white py-12 md:py-16 lg:py-[120px] px-5 md:px-10 lg:px-[180px]">
      <div className="max-w-[1368px] mx-auto">
        {/* Header */}
        <Reveal>
          <div className="text-center mb-12 lg:mb-16">
            <span className="inline-block rounded-full bg-[#e8edf7] px-4 py-1.5 text-sm font-medium text-[#122d63] mb-4">
              Governance
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-[42px] font-bold text-[#090d2c] leading-tight mb-4">
              Transparent Governance
            </h2>
            <p className="text-[#62636c] text-base md:text-lg max-w-[640px] mx-auto">
              Accountability and integrity in everything we do
            </p>
          </div>
        </Reveal>

        {/* Two-column layout */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* Left: Bullet list with blue checkmarks */}
          <Reveal>
            <ul className="space-y-5">
              {bulletItems.map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <span className="mt-1 flex-shrink-0">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="10" cy="10" r="10" fill="#122d63" />
                      <path
                        d="M6 10.5L8.5 13L14 7.5"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                  <span className="text-[#090d2c] text-base md:text-lg">
                    {item}
                  </span>
                </li>
              ))}
            </ul>
          </Reveal>

          {/* Right: Dark blue gradient card */}
          <Reveal>
            <div className="rounded-[24px] bg-gradient-to-br from-[#122d63] to-[#1a3a7a] p-8 md:p-10 lg:p-12 flex flex-col gap-6">
              <h3 className="text-2xl md:text-3xl font-bold text-white leading-tight">
                2024 Sustainability Report
              </h3>
              <p className="text-white/75 text-base md:text-lg leading-relaxed">
                Download our latest report detailing our environmental, social,
                and governance performance.
              </p>
              <button className="inline-flex items-center gap-2 self-start bg-white text-[#090d2c] font-semibold text-sm md:text-base px-6 py-3 rounded-full hover:bg-white/90 transition-colors">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9 2.25V12.75M9 12.75L4.5 8.25M9 12.75L13.5 8.25"
                    stroke="#090d2c"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M2.25 15.75H15.75"
                    stroke="#090d2c"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
                Download Report
              </button>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default GovernanceSection;
